export default axios => ({sentUserActivity: payload => axios.post('activity', payload)})
